import { Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: "inline-labeled-text",
    templateUrl: "./inline-labeled-text.component.html",
})
export class InlineLabeledTextComponent {
    @Input() public textLabel: string;
    @Input() public textValue: any;

    @Input() @HostBinding("style.margin-right") public marginRight = "20px";
    @Input() @HostBinding("style.margin-bottom") public marginBottom = "5px";
    @HostBinding("style.display") public displayValue = "block";

    public getText() {
        if (!this.textValue) { return; }
        if (typeof this.textValue === "object") { return this.textValue.join(", "); }
        return this.textValue;
    }
}
